import styles from './index.module.sass';

export const SortPicker = ({ selectedId, options, onClick }: IArgs) => {
  return ( <div className={styles.root}>
    { options.map((item, i) => (
        <SortItem item={item} key={i} selected={selectedId === item.value} onClick={(id) =>onClick(id)}/>
    )) }
  </div>);
};

interface IArgs {
  selectedId: number;
  options: SortItem[];
  onClick: (value: string | number) => void;
}

type SortItem = { value: string | number; label: string };

let SortItem = ({
  item,
  selected,
  onClick,
}: {
  item: SortItem;
  selected: boolean;
  onClick: (value: string | number) => void;
}) => (
  <div className={styles.sortItem} aria-selected={selected}  onClick={() => onClick(item.value)}>
    {item.label}
  </div>
);
